import { render, staticRenderFns } from "./selectunit.vue?vue&type=template&id=5c166f78&scoped=true"
import script from "./selectunit.vue?vue&type=script&lang=js"
export * from "./selectunit.vue?vue&type=script&lang=js"
import style0 from "./selectunit.vue?vue&type=style&index=0&id=5c166f78&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c166f78",
  null
  
)

export default component.exports